import { useParams } from 'react-router-dom';

/** Used in both: /employee and /employer routes. groupId is optional on both. */
export const useEmployeeEmployerProfileUrlParams = (): {
  groupId: string | undefined;
} => {
  const { groupId } = useParams<{ groupId?: string }>();

  return { groupId: groupId || undefined };
};
